import {useMemo} from 'react'
import {PlayerColor} from '@colonist/game-states'
import {UIGamePlayerInfoSectionContentUsedDevsProps} from '../../UIGamePlayerInfo'
import {useMechanicValidatorDevelopmentCard} from '../../../store/selectors/useMechanicValidatorDevelopmentCard'
import {cardEnumsToCardState} from '../../../utils/cards'

export const usePlayerInfoSectionContentUsedDevsProps = (playerColor: PlayerColor) => {
    const developmentCardsValidator = useMechanicValidatorDevelopmentCard()
    const usedDevelopmentCards = developmentCardsValidator?.getDevelopmentCardsPlayerState(playerColor).developmentCardsUsed
    if(usedDevelopmentCards == undefined) return null

    const cardStateUnordered = cardEnumsToCardState(usedDevelopmentCards)

    return useMemo<UIGamePlayerInfoSectionContentUsedDevsProps>(() => ({
        cardState: cardStateUnordered,
    }), [usedDevelopmentCards])
}
